import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8b42bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-notice" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search-block" }
const _hoisted_4 = {
  class: "area-table-container",
  ref: "sendNoticeTable"
}
const _hoisted_5 = { class: "creat-content" }
const _hoisted_6 = { class: "creat-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbBlock = _resolveComponent("BreadcrumbBlock")!
  const _component_Search = _resolveComponent("Search")!
  const _component_sendNoticeTable = _resolveComponent("sendNoticeTable")!
  const _component_creat = _resolveComponent("creat")!
  const _component_detail = _resolveComponent("detail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BreadcrumbBlock),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Search, {
          value: _ctx.searchData,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchData) = $event)),
          width: "1.6rem",
          placeholder: "请输入关键字搜索",
          onSearch: _ctx.onSearch
        }, null, 8, ["value", "onSearch"])
      ]),
      _createElementVNode("div", {
        class: "creat",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreat && _ctx.showCreat(...args)))
      }, "新建通知")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_sendNoticeTable, {
        areaTableData: _ctx.tableData,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        onShowDetail: _ctx.showDetail,
        scrollHeight: '6.4rem'
      }, null, 8, ["areaTableData", "columns", "pagination", "onShowDetail", "scrollHeight"])
    ], 512),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_component_creat, { onBackToList: _ctx.backToList }, null, 8, ["onBackToList"])
    ], 512), [
      [_vShow, _ctx.creatVisable]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createVNode(_component_detail, {
        curTableRow: _ctx.curTableRow,
        onBackToList: _ctx.backToList
      }, null, 8, ["curTableRow", "onBackToList"])
    ], 512), [
      [_vShow, _ctx.detailVisable]
    ])
  ]))
}